<div *ngFor="let link of listLinks; let i = index" class="input-group input-group-sm" [ngClass]="{'mt-1': i > 0}">
  <input type="url"
         autocomplete="off"
         attr.list="defaultURLs{{i}}"
         [id]="input.MainElementList[0].ID + i"
         class="col q-input-border q-bo"
         [disabled]="input.MainElementList[0].Disabled"
         [required]="input.MainElementList[0].Required"
         [ngClass]="setClass(input)"
         (change)="ChangeLinkValue(i, $event.target.value)"
         [value]="link">

  <!--<div *ngIf="!input.MainElementList[0].Disabled" class="input-group-append">-->
    <button *ngIf="!input.MainElementList[0].Disabled"
            (click)="RemoveFile(i)"
            [id]="input.MainElementList[0].ID + '_minus_btn_' + i"
            title="{{'RemoveLink'|trad}}"
            class="mr-1 ml-0 rounded-right q-btn q-danger q-bo">
      <i class="fas fa-minus"></i>
    </button>
  <!--</div>-->

  <!--<div *ngIf="input.MainElementList[1]" class="input-group-append">-->
    <button *ngIf="input.MainElementList[1] && input.MainElementList[1].Type === 'BUTTON'"
            class="mr-1 ml-0 q-btn q-bo q-main"
            (click)="navigToVideo(link)"
            [id]="input.MainElementList[1].ID"
            [title]="input.MainElementList[1].ToolTip"
            [disabled]="link.length < 1">
      <i class="{{input.MainElementList[1].Src}}"></i>
    </button>
  <!--</div>-->

 <!-- <div *ngIf="!input.MainElementList[0].Disabled && input.MainElementList[2]" class="input-group-append">-->
    <button *ngIf="!input.MainElementList[0].Disabled && input.MainElementList[2] && input.MainElementList[2].Type === 'BUTTON'"
            [ngClass]="{'invisible': i + 1 < listLinks.length}"
            class="mx-0 q-btn q-bo q-main"
            (click)="GetRecordedFiles()"
            [id]="input.MainElementList[2].ID"
            [title]="input.MainElementList[2].ToolTip"
            [disabled]="!idEvent || idEvent === '0'">
      <i class="{{input.MainElementList[2].Src}}"></i>
    </button>
  <!--</div>-->

  <!--<div *ngIf="!input.MainElementList[0].Disabled" [ngClass]="{'invisible': i + 1 < listLinks.length}" class="input-group-append">-->
    <button  *ngIf="!input.MainElementList[0].Disabled"
            [ngClass]="{'invisible': i + 1 < listLinks.length}"
            (click)="AddFile()"
            [id]="input.MainElementList[0].ID + '_minus_btn_' + i"
            title="ajouter un nouveau lien"
            class="ml-1 mr-0 q-btn q-bo q-primary">
      <i class="fas fa-plus"></i>
    </button>
  <!--</div>-->


  <datalist [id]="'defaultURLs' + i">
    <option *ngFor="let data of dataList" [value]="data.play_url">le {{data.recording_start | date: 'dd/MM/yyyy'}} de {{data.recording_start | date: 'HH:MM'}} à {{data.recording_end | date: 'HH:MM'}} type : {{data.recording_type | trad}}</option>
  </datalist>
</div>




